import loadScript from '@/helper/loadscript';
import {
  getUserInfo,
  loginByYoupin
} from '@/apis/base';
import { isInHsbApp, hsbApp } from '@@@/hsbh5/utils/hsbApp';
// import { isInWechat } from '@@@/hsbh5/utils/env';
import { Toast } from 'mint-ui';
import parse from 'url-parse';

const isInWechat = () => {
  return /MicroMessenger/i.exec(navigator.userAgent) !== null;
};

export default {
  namespaced: true,
  state: {
    resolvedRoute: null,
    next: null,
    successCallBack: null
  },
  mutations: {
    setAnyData (state, data = {}) {
      state[data.key] = data.val;
    },
    resetAnyData (state) {
      state.resolvedRoute = null;
      state.next = null;
      state.successCallBack = null;
    }
  },
  actions: {
    /*
     * @desc: 多端登录主入口
    */
    main ({ commit, dispatch, rootState }, params = {}) {
      /*
       * @param: resolvedRoute：下个页面的信息，主要去href、redirect
       * @param: next：钩子
      */
      const { resolvedRoute, nextRoute, next, router, success } = params;
      if (resolvedRoute || next) commit('resetAnyData');
      resolvedRoute && commit('setAnyData', { key: 'resolvedRoute', val: resolvedRoute });
      next && commit('setAnyData', { key: 'next', val: next });
      success && commit('setAnyData', { key: 'successCallBack', val: success });
      if (isInHsbApp() && +rootState.pid !== 1597) {
        // 自有APP登录
        dispatch('loginByHsbApp');
      } else if (+rootState.pid === 1196 && isInWechat()) {
        // 自有小程序登录
        dispatch('loginByHsbWechatMp');
      } else if (+rootState.pid === 1043 && isInWechat()) {
        // 自有h5公众号登录
        dispatch('loginByHsbWechat');
      } else if ([1439].includes(+rootState.pid)) {
        // 可乐APP/小程序登录
        dispatch('loginByCoco');
      } else {
        // 自有H5登录
        dispatch('loginByHsbH5', { router, nextRoute });
      }
    },
    /*
     * @desc: 自有H5登录
    */
    loginByHsbH5 ({ state, rootState }, params = {}) {
      const { next } = state;
      const { router, nextRoute } = params;
      if (next) {
        next(nextRoute || `/login?pid=${rootState.pid}`);
      } else {
        router && router.push(nextRoute || `/login?pid=${rootState.pid}`);
      }
    },
    /*
     * @desc: 自有h5公众号登录
    */
    loginByHsbWechat ({ commit, rootState }, params = {}) {
      const { loginType, auth2LoginUrl, platform } = rootState.config;
      const noCarryArr = ['eid', 'expire', 'openid', 'unionid', 'token', 'tel'];
      const { origin, pathname, query } = parse(window.location.href, true);
      let auth2CallBack = `${origin}${pathname}`;
      let querys = '';
      Object.keys(query).forEach(key => {
        if (!noCarryArr.includes(key)) {
          if (querys) {
            querys += `&${key}=${query[key]}`;
          } else {
            querys += `?${key}=${query[key]}`;
          }
        }
      });
      auth2CallBack = querys ? `${auth2CallBack}${querys}` : auth2CallBack;
      auth2CallBack = encodeURIComponent(auth2CallBack);
      let loginUrl = `${auth2LoginUrl}?redirectUri=${auth2CallBack}&platform=${platform}&pid=${rootState.pid}&oauthSite=${loginType}`;
      /**
       * 微信授权登录
       * loginWay: 1 需要授权
       * loginWay：2 不需要授权
       */
      if (loginType === 'wechat') loginUrl += '&loginWay=2';
      const urlObj = parse(loginUrl, true);
      window.location.replace(urlObj.toString());
    },
    /*
     * @desc: 自有小程序登录
    */
    loginByHsbWechatMp ({ commit }, params = {}) {
      window.wx.miniProgram.navigateTo({
        url: `/page/pages/login/index`
      });
    },
    /*
     * @desc: 自有APP登录
    */
    loginByHsbApp ({ state, dispatch }, params = {}) {
      window.hsbAppLoginCallback = function (res) {
        if (!res) {
          return Toast('登录失败: 回调函数为空');
        }
        if (typeof res === 'string') {
          res = JSON.parse(res);
        }
        if (+res._errCode === 0) {
          dispatch('getHsbUserInfo', { token: res._data.token });
        } else {
          Toast(res._errStr || '登录失败');
          const { resolvedRoute, next } = state;
          resolvedRoute && next && next(resolvedRoute.route.query.redirect);
        }
      };
      try {
        hsbApp.hsbAppLogin({ callback: 'hsbAppLoginCallback' });
      } catch (error) {
        Toast(error);
      }
    },
    /*
     * @desc: 可乐H5/APP/小程序登录
    */
    loginByCoco ({ state, dispatch }, params = {}) {
      if (window.cola) {
        window.cola.login().then(ret => {
          if (ret.token) {
            dispatch('changeHsbTokenByCoco', { token: ret.token });
          }
        });
      } else {
        dispatch('loadCocoLoginSDK');
      }
    },
    /*
     * @desc: 加载优品登录SDK
    */
    loadCocoLoginSDK ({ dispatch }) {
      loadScript('https://s1.huishoubao.com/colagoods/app/cola-sdk.2.3.8.js', () => {
        dispatch('loginByCoco');
      });
    },
    /*
     * @desc: 可乐token换回收宝token
    */
    async changeHsbTokenByCoco ({ dispatch }, { token, complete }) {
      try {
        let ret = await loginByYoupin({ openId: token });
        if (+ret._errCode === 0) {
          if (ret._data.token) {
            dispatch('getHsbUserInfo', { token: ret._data.token, complete });
          }
        } else {
          complete && complete(ret._errStr);
          Toast(ret._errStr);
        }
      } catch (error) {
        complete && complete(error);
      }
    },
    /*
     * @desc: 回收宝token换用户信息
    */
    async getHsbUserInfo ({ dispatch }, { token, complete }) {
      try {
        let ret = await getUserInfo(token);
        if (+ret._errCode === 0) {
          dispatch('afterLoginHooks', { token, userInfo: ret._data, complete });
        } else {
          complete && complete(ret._errStr);
          Toast(ret._errStr);
        }
      } catch (error) {
        complete && complete(error);
      }
    },
    /*
     * @desc: 存入用户信息、更新用户登录态及跳转处理
    */
    async afterLoginHooks ({ state, commit, dispatch, rootState }, { token, userInfo, complete }) {
      const { resolvedRoute, next } = state;
      await commit('user/setUserInfo', { tel: userInfo.tel, openid: userInfo.openid, eid: userInfo.eid }, { root: true });
      await commit('user/setToken', token, { root: true });
      await commit('setLoginState', true, { root: true });
      if (complete) {
        return complete();
      }
      if (isInWechat()) return;
      if (state.successCallBack) {
        /*
         * @场景: 主动调用登录回调函数
         * @功能: 登录成功后由调用方自行处理后续逻辑
        */
        state.successCallBack({ token, userInfo });
      } else if (resolvedRoute && next) {
        /*
         * @场景: 被动调用登录(检测登录态失效时)
         * @功能: 登录成功后跳转至目标页面
        */
        setTimeout(() => {
          next(resolvedRoute.route.query.redirect);
        }, 200);
      } else {
        /*
         * @场景: 主动调用登录，且不需要处理登录后的逻辑
         * @功能: 兜底方案
        */
        window.location.reload();
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/core/manyLogin/store.js